import { useIntl } from 'react-intl'
import { LoanRole } from '@matech/thebigpos-sdk'

// ToDo: Check to unify this Enum with roles const in client file
export enum RoleEnum {
	BuyerAgent = 'BuyerAgent',
	EscrowAgent = 'EscrowAgent',
	LoanOfficer = 'LoanOfficer',
	LoanOfficerAssistant = 'LoanOfficerAssistant',
	LoanProcessor = 'LoanProcessor',
	SellerAgent = 'SellerAgent',
	SettlementAgent = 'SettlementAgent',
	SupportingLoanOfficer = 'SupportingLoanOfficer',
	TitleInsuranceAgent = 'TitleInsuranceAgent',
}

export type RoleOptionItem = {
	value: LoanRole
	intlKey: string
}

export type ShareLoanRoleListOptions = {
	excludeRoles?: LoanRole[]
	includeRoles?: LoanRole[]
}

const ROLE_LIST: Omit<RoleOptionItem, 'label'>[] = [
	{ value: RoleEnum.BuyerAgent, intlKey: 'role.buyerAgent' },
	{ value: RoleEnum.EscrowAgent, intlKey: 'role.escrowAgent' },
	{ value: RoleEnum.LoanOfficer, intlKey: 'role.loanOfficer' },
	{
		value: RoleEnum.SupportingLoanOfficer,
		intlKey: 'role.supportingLoanOfficer',
	},
	{
		value: RoleEnum.LoanOfficerAssistant,
		intlKey: 'role.loanOfficerAssistant',
	},
	{
		value: RoleEnum.LoanProcessor,
		intlKey: 'role.loanProcessor',
	},
	{ value: RoleEnum.SellerAgent, intlKey: 'role.sellerAgent' },
	{
		value: RoleEnum.SettlementAgent,
		intlKey: 'role.settlementAgent',
	},
	{
		value: RoleEnum.TitleInsuranceAgent,
		intlKey: 'role.titleInsuranceAgent',
	},
]

export default function useRoleList(
	options?: ShareLoanRoleListOptions
) {
	const { formatMessage } = useIntl()
	const { excludeRoles = [], includeRoles } = options || {}

	let filteredRoles = ROLE_LIST

	if (includeRoles && includeRoles.length > 0)
		filteredRoles = filteredRoles.filter((role) =>
			includeRoles.includes(role.value)
		)

	if (excludeRoles.length > 0)
		filteredRoles = filteredRoles.filter(
			(role) => !excludeRoles.includes(role.value)
		)

	return filteredRoles.map((role) => ({
		value: role.value,
		label: formatMessage({ id: role.intlKey }),
	}))
}
